import ApiConnector from "../connector/ApiConnector";
import { useImmer } from "use-immer";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import UtilService from "../service/UtilService";
import AuthService from "../service/AuthService";
import packageJson from "../../package.json";

const Component = (props) => {
  const [version, updateVersion] = useImmer(null);
  const [clientVersion, updateClientVersion] = useImmer(null);

  useEffect(async () => {
    const _version = await ApiConnector.getVersion();
    const _clientVersion = packageJson.version;

    const versionParts = _version.split(".");
    const clientVersionParts = _clientVersion.split(".");
    const isVersionMatch =
      versionParts[0] == clientVersionParts[0] &&
      versionParts[1] == clientVersionParts[1];
    if (!isVersionMatch) {
      window.alert(
        "There is currently Release ongoing. Please try to login again later (after 5 minutes), or contact IT Department.\n\nDetails:\n\nPablo version: " +
          _version +
          "\nPablo client version: " +
          _clientVersion +
          "\nVersions have to match.",
      );
      AuthService.logout();
    }

    updateVersion(_version);
    updateClientVersion(_clientVersion);
  }, []);

  return (
    <>
      <header className="subheader header-with-save">
        <h1>PABLO</h1>
      </header>
      <main>
        <p>
          PABLO is anti-fraud service which measures fraud risk level of
          authorization transactions and decides whether it should be blocked
          <span
            onClick={() =>
              UtilService.copyToClipboard(AuthService.getIdToken())
            }
          ></span>
        </p>
        <p>
          Documentation:{" "}
          <a href="https://confluence.eurowag.com/display/AFS/PABLO+-+Prediction+and+Block">
            confluence.eurowag.com
          </a>
        </p>
        <p>Version: {version}</p>
        <p>Client version: {clientVersion}</p>
        <Link to="/auditlog">View audit log</Link>
      </main>
    </>
  );
};

export default Component;
